/***
 * Created on 2023/8/29
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import AddPhoneStep1 from "./add_phone/add_phone_step_1";
import AddPhoneStep2 from "./add_phone/add_phone_step_2";
import {useCountdown} from "../../../../common/countdown";
import {useQuery} from "@tanstack/react-query";
import {apiGet} from "../../../../../service/api";
import {useOnChange} from "../../../../../hook/form";
import AddPhoneStep3 from "./add_phone/add_phone_step_3";


function AddPhoneWizard({dispatch, state}) {
    const {seconds, setSeconds} = useCountdown(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const {values, setValues, onChange} = useOnChange({
        country_code: '',
        phone: '',
        code: '',
        verify_type: state?.opts?.method || 'sms_1',
        send_type: state?.opts?.method || 'sms_1',
        event_type: state?.opts?.action || ""
    });

    const countdown = useQuery({
        queryKey: ['get_countdown'],
        queryFn: async () => {
            const data = await apiGet('/ajax/countdown');
            const now = new Date().getTime();
            const value = Math.round((now - data?.countdown) / 1000) || 0;
            setSeconds(value > 60 ? 0 : 60 - value);
            return data;
        }
    });

    const closeWizard = () => {
        dispatch({type: 'toggleAddPhone', value: false});
    }

    return (
        <>
            {currentIndex === 0 && <AddPhoneStep1 show={currentIndex===0} closeWizard={closeWizard} next={()=>setCurrentIndex(prev=>prev+1)}
                                                  metadata={{seconds, setSeconds, values, setValues, onChange}}/>}
            {currentIndex === 1 && <AddPhoneStep2 show={currentIndex===1} closeWizard={closeWizard} next={()=>dispatch({type: 'toggleSigninAgain', value: true})} prev={()=>setCurrentIndex(prev=>prev-1)}
                                                  metadata={{values, setValues, onChange}}/>}
            {currentIndex === 2 && <AddPhoneStep3 show={currentIndex===2} closeWizard={closeWizard} dispatch={dispatch} state={state}/>}
        </>
    );
}

export default AddPhoneWizard;